import tokens from "./tokens.json";

export { tokens };
export type Tokens = typeof tokens;

const kebab = (s: string) => s.replace(/[A-Z0-9]+/g, (m) => `-${m.toLowerCase()}`);

/** Web 用の CSS 変数（:root）。値はここからだけ作る */
export function tokensToCss(): string {
  const v: string[] = [];
  for (const [k, val] of Object.entries(tokens.color)) v.push(`--color-${kebab(k)}:${val}`);
  tokens.process.forEach((c, i) => {
    v.push(`--process-${i + 1}:${c}`);
  });
  for (const [k, val] of Object.entries(tokens.gradient)) v.push(`--grad-${kebab(k)}:${val}`);
  for (const [k, val] of Object.entries(tokens.font)) v.push(`--font-${kebab(k)}:${val}`);
  for (const [k, val] of Object.entries(tokens.fontSize)) v.push(`--fs-${kebab(k)}:${val}px`);
  tokens.space.forEach((s, i) => {
    v.push(`--sp-${i + 1}:${s}px`);
  });
  for (const [k, val] of Object.entries(tokens.radius)) v.push(`--radius-${kebab(k)}:${val}px`);
  for (const [k, val] of Object.entries(tokens.shadow)) v.push(`--shadow-${kebab(k)}:${val}`);
  for (const [k, val] of Object.entries(tokens.control)) v.push(`--control-${kebab(k)}:${val}px`);
  for (const [k, val] of Object.entries(tokens.icon)) v.push(`--ico-${kebab(k)}:${val}px`);
  for (const [k, val] of Object.entries(tokens.layout)) v.push(`--${kebab(k)}:${val}px`);
  for (const [k, val] of Object.entries(tokens.motion)) v.push(`--motion-${kebab(k)}:${val}`);
  return `:root{${v.join(";")}}`;
}
